import React, { Component } from 'react';
import './MyLink.css';

class MyLink extends Component {
  
  constructor(props) {
    super(props);

    // init my data
    this.setData();

  }

  setData(){
    if(!this.props.type)
      return;

    this.text = this.props.title ? this.props.title : 'Visit my %s profile';

    switch(this.props.type.toString().toLowerCase()){
      case 'github':
        this.url = 'https://github.com/';
        this.icon = 'fa-github';
        this.text = this.text.replace('%s','Github');
      break;
      case 'twitter':
      case 'tw':
        this.url = 'https://twitter.com/';
        this.icon = 'fa-twitter';
        this.text = this.text.replace('%s','Twitter');
      break;
      case 'facebook':
      case 'fb':
        this.url = 'https://twitter.com/';
        this.icon = 'fa-facebook';
        this.text = this.text.replace('%s','Facebook');
      break;
      case 'wordpress':
      case 'wp':
        this.url = 'https://profiles.wordpress.org/';
        this.icon = 'fa-wordpress';
        this.text = this.text.replace('%s','WordPress');
      break;
      case 'linkedin':
        this.url = 'https://it.linkedin.com/in/';
        this.icon = 'fa-linkedin';
        this.text = this.text.replace('%s','LinkedIn');
      break;
      case 'curriculum':
      case 'cv':
        this.url = '';
        this.icon = 'fa-file-text-o';
        this.text = 'Read my Curriculum';
      break;
      default:
        return;
    }

    this.icon = 'fa '+this.icon;
    this.url += this.props.name ? this.props.name : '';
  }

  componentDidMount() {
  }

  render() {

    if(!this.url){
      return (
          <span>Missing data</span>
        );
    }

    return (
      <div className="my-link-wrap">
        <a href={this.url} className={this.icon} title={this.text}></a>
      </div>
    );

  }
}

export default MyLink;



// WEBPACK FOOTER //
// ./src/MyLink.js